import { useAuth, overrideConfig } from '@/api/cost-search'

const fetchCostPivot = function ({ qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    const params = {
        groupIdx,
        projectIdx,
        indexes,
        compositSources,
        pivotFilter,
        minDate,
        maxDate,
        value
    }
    return auth.axiosIns.post(`/v1/api/costpivot/qtype/${qtype}`, params, { headers: { 'service-namespace': 'platform-x' } })
}

const fetchUserTag = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get('/v1/api/usertag')
}
const fetchCostPivotDownload = function ({ dType, qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, serviceIdx, dataToken) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx, dataToken })
    const params = {
        groupIdx,
        projectIdx,
        indexes,
        compositSources,
        pivotFilter,
        minDate,
        maxDate,
        value
    }
    return auth.axiosIns.post(`v1/api/async/costpivot/qtype/${qtype}/dtype/${dType}`, params, { skipAutoProgress: true })
}
const fetchCostPivotDownloadStatus = function (serviceIdx, dataToken) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx, dataToken })
    return auth.axiosIns.get('/v1/api/async/costpivot/status', { skipAutoProgress: true })
}
const fetchCostDownload = function ({ qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    const params = {
        groupIdx,
        projectIdx,
        indexes,
        compositSources,
        pivotFilter,
        minDate,
        maxDate,
        value
    }
    return auth.axiosIns.post(`/v1/api/async/costdownload/qtype/${qtype}`, params, { headers: { 'service-namespace': 'platform-x' }, skipAutoProgress: true })
}
const fetchCostDownloadStatus = function (serviceIdx, dataToken) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx, dataToken })
    return auth.axiosIns.get('/v1/api/async/costdownload/status', { skipAutoProgress: true })
}
const fetchCostDownloadPeriod = function ({ qtype, projectIdx, groupIdx }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    const params = {
        groupIdx,
        projectIdx
    }
    return auth.axiosIns.post(`/v1/api/async/costdownload/period/qtype/${qtype}`, params, { headers: { 'service-namespace': 'platform-x' } })
}
export default {
    fetchCostPivot,
    fetchUserTag,
    fetchCostPivotDownload,
    fetchCostPivotDownloadStatus,
    fetchCostDownload,
    fetchCostDownloadStatus,
    fetchCostDownloadPeriod
}
